var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00032 14.2698L13.1503 16.7798C13.9103 17.2398 14.8403 16.5598 14.6403 15.6998L13.5403 10.9798L17.2103 7.79977C17.8803 7.21977 17.5203 6.11977 16.6403 6.04977L11.8103 5.63977L9.92032 1.17977C9.58032 0.369766 8.42032 0.369766 8.08032 1.17977L6.19032 5.62977L1.36032 6.03977C0.480317 6.10977 0.120317 7.20977 0.790317 7.78977L4.46032 10.9698L3.36032 15.6898C3.16032 16.5498 4.09032 17.2298 4.85032 16.7698L9.00032 14.2698Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileStar);
export default __webpack_public_path__ + "static/media/fileStar.c1064cc3a31b8530cf1184084d3a9daf.svg";
export { ForwardRef as ReactComponent };